<template>
  <div>
    <dataHomeMenu v-if="connected" @logout="logout"></dataHomeMenu>
    <login v-if="!connected" @logged="successConnected"></login>
    
  </div>

</template>

<script>
import LoginComponent from "./components/Login/LoginMenu";
import MenuComponent from "./components/Menu";

import tokenStore from "./store/TokenStore";
import languageStore from "./store/LanguageStore";

export default {
  data: () => ({
    connected: false
  }),
  components: {
    login: LoginComponent,
    dataHomeMenu: MenuComponent
  },
  methods: {
    successConnected: function() {
      if (tokenStore.getToken() != null) {
        this.connected = true;
        //console.log("connected")
      }
    },
    logout: function() {
      tokenStore.removeToken();
      this.connected = false;
      //console.log("logout")
    }
  },
  beforeMount: function() {
    languageStore.initializeLang();
    if (tokenStore.getToken() != null) {
      tokenStore.refreshToken();
      this.connected = true;
    }
  }
};
</script>
